<template>
  <div class="d-flex align-center py-0">
    <div class="left">
      <span class="radio-group-label mr-2 mb-0">Authentication:</span>
    </div>
    <div class="right ml-4">
      <v-radio-group
        v-model="method"
        row
        hide-details
        class="ma-0"
        @change="methodChanged"
      >
        <v-radio :value="1" label="Email"></v-radio>
        <!-- <v-radio :value="2" label="SMS" @click="allowTwoStepChanged"></v-radio> -->
        <v-radio :value="0" label="None"></v-radio>
      </v-radio-group>
    </div>
  </div>

  <!-- <div class="d-flex light-text">
    <span class="mt-1">{{ label }}:</span>
    <v-text-field
      v-model="timezoneOffsetInputValue"
      :disabled="disabled"
      height="18px"
      class="mw-30 ma-0 pa-0 mx-2 offset-ammount"
      style="margin-top: 7px !important"
      type="number"
      hide-details
      @input="offsetTypeChanged"
    >
    </v-text-field>
    <v-select
      v-model="offsetType"
      @input="offsetTypeChanged"
      class="pa-0 mw-100"
      style="margin-top: 5px !important"
      height="16px"
      hide-details
      :items="[
        { text: 'Hours', value: 60 },
        { text: 'Minutes', value: 1 },
      ]"
    ></v-select>
  </div> -->
</template>

<script>
export default {
  name: 'TimezoneOffset',
  data() {
    return {
      method: 0,
    }
  },
  props: {
    originalMethod: Number,
  },
  emits: ['method-changed', 'allow-two-step-changed'],
  //   computed: {
  //     pathRules(value) {
  //       return [
  //         value => !!value || value === '' || 'Required',
  //         value => isFolderNameValid(value) || 'Path is not valid',
  //       ]
  //     },
  //   },
  methods: {
    methodChanged() {
      this.$emit('method-changed', this.method)
    },
    allowTwoStepChanged() {
      this.$emit('allow-two-step-changed', this.method === 2)
    },
  },
    created() {
      this.method = this.originalMethod
    },
}
</script>

<style scoped>
.radio-group-label {
  width: 40%;
  max-width: 380px;
}
span {
  font-size: 16px;
  line-height: 36px;
  opacity: 0.8;
}
</style>
